import SelectComponent from '@componentes/select/select.component';
import { apiUrl } from '@constants/defaultValues';
import { httpRequest } from '@util/api-common.util';
import WebapiCommon from '@util/webapi.common';
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Button,
    Row,
    Col,
} from 'reactstrap';
import IntlMessage from '../../../helpers/intlMessage';

const ModalEncaminhar = (props) => {
    
    const {messages}=props.intl;
    const [medicos, setMedicos] = useState([])
    const [medicoSelecionado, setMedicoSelecionado] = useState('')

    useEffect(() => {
        WebapiCommon.getMedicos().then((res) => {
            setMedicos(res)
        })
    }, [])

    const encaminhar = () => {
        httpRequest(`Encaminhamento/Encaminhar`, 'PATCH',
            {
                "laudoId": props.laudo,
                "medicoId": medicoSelecionado.value
            },
        ).then((res) => {
            props.commonActions.showAlerta(
                'sucesso',
                res.message,
                1500);
            props.confirmar()
            setMedicoSelecionado('')
        }).catch((err) => {
            props.commonActions.showAlerta('alerta',
                err.data,
                1500);
            setMedicoSelecionado('')
            props.confirmar()
        })
    }

    const onChangeMedico = (e) => {
        setMedicoSelecionado(e)
    }

    return (
        <Modal
            className='modal-confirm'
            centered
            isOpen={props.showModalEncaminhar}
            toggle={props.toggleModalEncaminhar}
        >
            <ModalHeader
                toggle={
                    !props.close
                        ? props.toggleModalEncaminhar
                        : props.close
                }
            >
                <IntlMessage id='dashboards.referral.referral' />
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col>
                        <SelectComponent
                            options={medicos}
                            value={medicoSelecionado}
                            onChange={(e) => {
                                onChangeMedico(e)
                            }}
                            placeholder={messages['dashboards.referral.doctorAssigned']}
                            styles={{ borderColor: 'transparent' }}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={
                        !props.cancelar
                            ? props.toggleModalEncaminhar
                            : props.cancelar
                    }
                    className={`button-cancel-${props.type}`}
                    color='secondary'
                >
                    <IntlMessage id="dashboards.examDetails.cancel" />
                </Button>
                <Button
                    className={`button-confirm-${props.type}`}
                    onClick={encaminhar}
                    disabled={props.disabled}
                    color='primary'
                >
                    {props.type === 'confirm' ? <IntlMessage id="dashboards.examDetails.confirm" /> : 'OK'}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default injectIntl(ModalEncaminhar) 


// WEBPACK FOOTER //
// ./src/app/common/modalEncaminhar/modalEncaminhar.js